import jump from 'src/helper/jumpToApp'
import brower from 'src/helper/brower'

export const openStore = function () {
  let { appLink } = jump
  let { AppStore, googlePlay } = appLink
  let url = brower.isIphone() ? AppStore : googlePlay
  window.location.href = url
}



// WEBPACK FOOTER //
// src/helper/openStore.js